<template>
  <div>
    <breadcrumb :items="breadcrumbs"></breadcrumb>
    <v-container fluid class="mt-5">
      <v-form
        ref="form"
        v-model="valid"
        lazy-validation
        @submit.prevent="registerDrug"
      >
        <div class="registration-section">
          <div class="main-register">
            <div class="registration-heading">
              <h2>{{ $t("drug.drugRegistration") }}</h2>
            </div>
            <div class="registration-btn">
              <v-btn
                width="146"
                class="mr-2"
                outlined
                color="primary"
                exact
                :to="{ name: 'DrugList' }"
                >{{ $t("actionListmod.cANCEL") }}</v-btn
              >
              <v-btn type="submit" width="146" color="primary">{{
                $t("actionListmod.sUBMIT")
              }}</v-btn>
            </div>
          </div>
          <v-expansion-panels focusable flat class="mt-5" v-model="panel">
            <v-expansion-panel>
              <v-expansion-panel-header class="text-h6 font-weight-bold">
                {{ $t("drug.drugInformation") }}</v-expansion-panel-header
              >
              <v-expansion-panel-content>
                <!-- <h2 class="mandatory">* Mandatory</h2> -->
                <div class="drug-form">
                  <!-- <button
                  type="button"
                  class="accordion"
                  @click="showHideSection('requiredFields')"
                >
                  Drug Information
                  <v-icon> mdi-chevron-down </v-icon>
                </button> -->
                  <div class="mt-5">
                    <v-row class="pa-5">
                      <v-col lg="4" md="4" sm="4" xs="6">
                        <div class="form-group">
                          <div class="cell-2">
                            <label for="exampleInputEmail1">{{ $t('drug.drugId') }}</label>
                          </div>
                          <v-text-field
                            v-model="drugToAdd.drugNumber"
                            placeholder="e.g #DM03992word"
                            outlined
                            dense
                          ></v-text-field>
                        </div>
                      </v-col>
                      <v-col lg="4" md="4" sm="4" xs="6">
                        <div class="form-group">
                          <label for="drugName"
                            >{{ $t("drug.drugName") }} <span>*</span></label
                          >
                          <v-tooltip top color="black" max-width="350">
                            <template v-slot:activator="{ on, attrs }">
                              <v-icon
                                small
                                v-bind="attrs"
                                v-on="on"
                                class="ml-2"
                              >
                                mdi-information-outline
                              </v-icon>
                            </template>
                            <span>{{ $t("drug.drugName") }}</span>
                          </v-tooltip>
                          <v-text-field
                            type="text"
                            v-model="drugToAdd.drugName"
                            :placeholder="$t('drug.drugName')"
                            outlined
                            dense
                            :rules="drugRules.drugName"
                          ></v-text-field>
                        </div>
                      </v-col>
                      <v-col lg="4" md="4" sm="4" xs="6">
                        <div class="form-group">
                          <label for="text"
                            >{{ $t("drug.drugGenericname") }} <span>*</span>
                            <v-tooltip top color="black" max-width="350">
                              <template v-slot:activator="{ on, attrs }">
                                <v-icon
                                  small
                                  v-bind="attrs"
                                  v-on="on"
                                  class="ml-2"
                                >
                                  mdi-information-outline
                                </v-icon>
                              </template>
                              <span>{{
                                $t("drug.drugGenericnameStatement")
                              }}</span>
                            </v-tooltip>
                          </label>

                          <v-text-field
                            type="text"
                            v-model="drugToAdd.genericName"
                            :placeholder="$t('drug.drugGenericname')"
                            outlined
                            dense
                            :rules="drugRules.genericName"
                          ></v-text-field>
                        </div>
                      </v-col>
                      <v-col lg="4" md="4" sm="4" xs="6">
                        <div class="form-group">
                          <label for="text">{{ $t("drug.drugFormat") }}</label>
                          <v-tooltip top color="black" max-width="350">
                            <template v-slot:activator="{ on, attrs }">
                              <v-icon
                                small
                                v-bind="attrs"
                                v-on="on"
                                class="ml-2"
                              >
                                mdi-information-outline
                              </v-icon>
                            </template>
                            <span>{{ $t("drug.drugFormat") }}</span>
                          </v-tooltip>
                          <v-text-field
                            type="text"
                            v-model="drugToAdd.drugFormat"
                            :placeholder="$t('drug.drugFormat')"
                            outlined
                            dense
                            :rules="drugRules.drugFormat"
                          ></v-text-field>
                        </div>
                      </v-col>
                      <v-col lg="4" md="4" sm="4" xs="6">
                        <div class="form-group">
                          <label for="drugDistributor"
                            >{{ $t("drug.drugDistributor") }} <span>*</span>
                            <v-tooltip top color="black" max-width="350">
                              <template v-slot:activator="{ on, attrs }">
                                <v-icon
                                  small
                                  v-bind="attrs"
                                  v-on="on"
                                  class="ml-2"
                                >
                                  mdi-information-outline
                                </v-icon>
                              </template>
                              <span>{{
                                $t("drug.drugDistributorStatement")
                              }}</span>
                            </v-tooltip>
                          </label>

                          <v-text-field
                            type="text"
                            v-model="drugToAdd.distributor"
                            placeholder="e.g XXXX"
                            outlined
                            dense
                            :rules="drugRules.distributor"
                          ></v-text-field>
                        </div>
                      </v-col>
                      <v-col lg="4" md="4" sm="4" xs="6">
                        <div class="form-group">
                          <label for="drugRegdate"
                            >{{ $t("drug.drugRegistrationdate") }}
                            <span>*</span>
                            <v-tooltip top color="black" max-width="350">
                              <template v-slot:activator="{ on, attrs }">
                                <v-icon
                                  small
                                  v-bind="attrs"
                                  v-on="on"
                                  class="ml-2"
                                >
                                  mdi-information-outline
                                </v-icon>
                              </template>
                              <span>{{
                                $t("drug.drugRegistrationdateStatement")
                              }}</span>
                            </v-tooltip>
                          </label>

                          <v-menu
                            v-model="drugRegmenu"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            transition="scale-transition"
                            offset-y
                            min-width="auto"
                          >
                            <template v-slot:activator="{ on, attrs }">
                              <v-text-field
                                v-model="drugToAdd.registrationDate"
                                append-icon="mdi-calendar"
                                outlined
                                dense
                                placeholder="e.g XXXX"
                                readonly
                                v-bind="attrs"
                                v-on="on"
                                :rules="drugRules.registrationDate"
                              ></v-text-field>
                            </template>
                            <v-date-picker
                              v-model="drugToAdd.registrationDate"
                              @input="drugRegmenu = false"
                              :min="new Date().toISOString().substr(0, 10)"
                            ></v-date-picker>
                          </v-menu>
                        </div>
                      </v-col>
                      <v-col lg="4" md="4" sm="4" xs="6">
                        <div class="form-group">
                          <label for="text"
                            >{{ $t("drug.drugManufacturer") }} <span>*</span>
                            <v-tooltip top color="black" max-width="350">
                              <template v-slot:activator="{ on, attrs }">
                                <v-icon
                                  small
                                  v-bind="attrs"
                                  v-on="on"
                                  class="ml-2"
                                >
                                  mdi-information-outline
                                </v-icon>
                              </template>
                              <span>{{
                                $t("drug.drugManufacturerStatement")
                              }}</span>
                            </v-tooltip>
                          </label>

                          <v-text-field
                            type="text"
                            v-model="drugToAdd.manufacturer"
                            placeholder="John Doe"
                            outlined
                            dense
                            :rules="drugRules.manufacturer"
                          ></v-text-field>
                        </div>
                      </v-col>
                      <!-- <v-col cols="3" class="display-none"></v-col> -->
                      <v-col lg="4" md="4" sm="4" xs="6">
                        <div class="form-group">
                          <label for="activeIngredient"
                            >{{ $t("drug.drugActiveingridents") }}
                            <span>*</span></label
                          >
                          <v-tooltip top color="black" max-width="350">
                            <template v-slot:activator="{ on, attrs }">
                              <v-icon
                                small
                                v-bind="attrs"
                                v-on="on"
                                class="ml-2"
                              >
                                mdi-information-outline
                              </v-icon>
                            </template>
                            <span>{{
                              $t("drug.drugActiveingridentsStatement")
                            }}</span>
                          </v-tooltip>
                          <v-text-field
                            type="text"
                            v-model="drugToAdd.activeIngredients"
                            placeholder="e.g XXKG"
                            outlined
                            dense
                            :rules="drugRules.activeIngredients"
                          ></v-text-field>
                        </div>
                      </v-col>

                      <!-- <v-col lg="4" md="4" sm="4" xs="6">
                        <div class="form-group">
                        <label>{{$t('drug.drugDozecalf')}}</label>
                        <v-tooltip top color="black" max-width="350">
                            <template v-slot:activator="{ on, attrs }">
                              <v-icon small v-bind="attrs" v-on="on" class="ml-2">
                                mdi-information-outline
                              </v-icon>
                            </template>
                            <span>{{$t('drug.drugDozecalfSatement')}}</span>
                          </v-tooltip>
                        <v-layout row>
                          <v-col cols="col">
                            <v-text-field
                              v-model="drugToAdd.dozeForCalf"
                              :placeholder="$t('drug.drugDozecalfSatement')"
                              outlined
                              dense
                            ></v-text-field>
                          </v-col>
                          <v-col cols="col">
                            <v-select
                              v-model="drugToAdd.dozeForCalfUom"
                              :items="unit"
                              placeholder="Select Unit"
                              outlined
                              dense
                            ></v-select>
                          </v-col>
                        </v-layout>
                        </div>
                      </v-col>
                      <v-col lg="4" md="4" sm="4" xs="6">
                        <div class="form-group">
                        <label>{{$t('drug.drugDozedam')}}</label>
                        <v-tooltip top color="black" max-width="350">
                            <template v-slot:activator="{ on, attrs }">
                              <v-icon small v-bind="attrs" v-on="on" class="ml-2">
                                mdi-information-outline
                              </v-icon>
                            </template>
                            <span>{{$t('drug.drugDozedamStatement')}}</span>
                          </v-tooltip>
                        <v-layout row>
                          <v-col cols>
                            <v-text-field
                              v-model="drugToAdd.dozeForDam"
                              :placeholder="$t('drug.drugDozedam')"
                              outlined
                              dense
                            ></v-text-field>
                          </v-col>
                          <v-col cols>
                            <v-select
                              v-model="drugToAdd.dozeForDamUom"
                              :items="unit"
                              placeholder="Select Unit"
                              outlined
                              dense
                            ></v-select>
                          </v-col>
                        </v-layout>
                        </div>
                      </v-col>
                      -->
                      <v-col lg="4" md="4" sm="4" xs="6">
                        <div class="form-group">
                          <label for="owner"
                            >{{ $t("drug.drugSubstitutionId") }} <span>*</span>
                            <v-tooltip top color="black" max-width="350">
                              <template v-slot:activator="{ on, attrs }">
                                <v-icon
                                  small
                                  v-bind="attrs"
                                  v-on="on"
                                  class="ml-2"
                                >
                                  mdi-information-outline
                                </v-icon>
                              </template>
                              <span>{{
                                $t("drug.drugSubstitutionIdStatement")
                              }}</span>
                            </v-tooltip>
                          </label>

                          <v-text-field
                            type="text"
                            v-model="drugToAdd.substituteDrugNo"
                            placeholder="e.g XXXX"
                            outlined
                            dense
                            :rules="drugRules.substituteDrugNo"
                          ></v-text-field>
                        </div>
                      </v-col>
                      <v-col lg="4" md="4" sm="4" xs="6">
                        <div class="form-group">
                          <label for="text"
                            >{{ $t("drug.packId") }}
                            <v-tooltip top color="black" max-width="350">
                              <template v-slot:activator="{ on, attrs }">
                                <v-icon
                                  small
                                  v-bind="attrs"
                                  v-on="on"
                                  class="ml-2"
                                >
                                  mdi-information-outline
                                </v-icon>
                              </template>
                              <span>{{ $t("drug.packIdStatement") }}</span>
                            </v-tooltip>
                          </label>

                          <v-text-field
                            type="text"
                            v-model="drugToAdd.packId"
                            placeholder="packId"
                            outlined
                            dense
                            :rules="drugRules.packId"
                          ></v-text-field>
                        </div>
                      </v-col>
                      <v-col lg="4" md="4" sm="4" xs="6">
                        <div class="form-group">
                          <label for="sire"
                            >{{ $t("drug.packBatchNumber") }}
                            <v-tooltip top color="black" max-width="350">
                              <template v-slot:activator="{ on, attrs }">
                                <v-icon
                                  small
                                  v-bind="attrs"
                                  v-on="on"
                                  class="ml-2"
                                >
                                  mdi-information-outline
                                </v-icon>
                              </template>
                              <span>{{
                                $t("drug.packBatchNumberStatement")
                              }}</span>
                            </v-tooltip>
                          </label>

                          <v-text-field
                            type="number"
                            v-model="drugToAdd.packBatchNumber"
                            placeholder="Batch Number"
                            outlined
                            dense
                            :rules="drugRules.packBatchNumber"
                          ></v-text-field>
                        </div>
                      </v-col>
                    </v-row>
                  </div>
                </div>
              </v-expansion-panel-content>
            </v-expansion-panel>
            <v-expansion-panel class="mt-2">
              <v-expansion-panel-header
                :elevation="0"
                class="text-h6 font-weight-bold"
              >
                {{ $t("drug.packExpiration") }}</v-expansion-panel-header
              >
              <v-expansion-panel-content>
                <!-- <button
              type="button"
              class="accordion"
              @click="showHideSection('packExpiration')"
            >
              Pack Expiration
              <v-icon> mdi-chevron-down </v-icon>
            </button> -->
                <div class="mt-5">
                  <v-row class="pa-5">
                    <v-col lg="4" md="4" sm="4" xs="6">
                      <div class="form-group">
                        <label for="drugRegdate">{{
                          $t("drug.packManufacturedDate")
                        }}</label>
                        <v-tooltip top color="black" max-width="350">
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon small v-bind="attrs" v-on="on" class="ml-2">
                              mdi-information-outline
                            </v-icon>
                          </template>
                          <span>{{
                            $t("drug.packManufacturedDateStatement")
                          }}</span>
                        </v-tooltip>
                        <v-menu
                          v-model="drugMfgmenu"
                          :close-on-content-click="false"
                          :nudge-right="40"
                          transition="scale-transition"
                          offset-y
                          min-width="auto"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              v-model="drugToAdd.packManufacturedDate"
                              append-icon="mdi-calendar"
                              outlined
                              placeholder="manufacture Date"
                              dense
                              readonly
                              v-bind="attrs"
                              v-on="on"
                            ></v-text-field>
                          </template>
                          <v-date-picker
                            v-model="drugToAdd.packManufacturedDate"
                            @input="drugMfgmenu = false"
                            :max="new Date().toISOString().substr(0, 10)"
                            @change="setExpire(drugToAdd.packManufacturedDate)"
                          ></v-date-picker>
                        </v-menu>
                      </div>
                    </v-col>
                    <!-- <v-col lg="4" md="4" sm="4" xs="6">
                      <div class="form-group">
                        <label for="drugRegdate">{{$t('drug.packImportedDate')}} </label>
                        <v-tooltip top color="black" max-width="350">
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon small v-bind="attrs" v-on="on" class="ml-2">
                              mdi-information-outline
                            </v-icon>
                          </template>
                          <span>{{$t('drug.packImportedDateStatement')}}</span>
                        </v-tooltip>
                        <v-menu
                          v-model="importedmenu"
                          :close-on-content-click="false"
                          :nudge-right="40"
                          transition="scale-transition"
                          offset-y
                          min-width="auto"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              v-model="drugToAdd.packImportedDate"
                              append-icon="mdi-calendar"
                              outlined
                              dense
                              readonly
                              placeholder="Imported Date"
                              v-bind="attrs"
                              v-on="on"
                              :error-messages="errors.packImportedDate"
                              :disabled="!drugToAdd.PackExpirationDate"
                            ></v-text-field>
                          </template>
                          <v-date-picker
                            v-model="drugToAdd.packImportedDate"
                            @input="importedmenu = false"
                             :min="drugToAdd.packManufacturedDate"
                             :max="drugToAdd.PackExpirationDate"
                          ></v-date-picker>
                        </v-menu>
                      </div>
                    </v-col> -->

                    <v-col lg="4" md="4" sm="4" xs="6">
                      <div class="form-group">
                        <label for="text">{{
                          $t("drug.packTotalVolumeLeft")
                        }}</label>
                        <v-tooltip top color="black" max-width="350">
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon small v-bind="attrs" v-on="on" class="ml-2">
                              mdi-information-outline
                            </v-icon>
                          </template>
                          <span>{{ $t("drug.packTotalVolumeLeftState") }}</span>
                        </v-tooltip>
                        <v-row>
                          <v-col lg="6" md="6" sm="6">
                            <v-text-field
                              type="number"
                              v-model="drugToAdd.packTotalVolLeft"
                              placeholder="e.g. 123"
                              outlined
                              dense
                              :rules="drugRules.packTotalVolLeft"
                            ></v-text-field>
                          </v-col>
                          <v-col lg="6" md="6" sm="6">
                            <v-select
                              v-model="drugToAdd.packTotalVolLeftUnit"
                              :items="uni"
                              placeholder="Unit"
                              outlined
                              dense
                            ></v-select>
                          </v-col>
                        </v-row>
                      </div>
                    </v-col>

                    <v-col lg="4" md="4" sm="4" xs="6">
                      <div class="form-group">
                        <label for="drugRegdate">{{
                          $t("drug.packExpirationDate")
                        }}</label>
                        <v-tooltip top color="black" max-width="350">
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon small v-bind="attrs" v-on="on" class="ml-2">
                              mdi-information-outline
                            </v-icon>
                          </template>
                          <span>{{
                            $t("drug.packExpirationDateStatement")
                          }}</span>
                        </v-tooltip>
                        <v-menu
                          v-model="packexpmenu"
                          :close-on-content-click="false"
                          :nudge-right="40"
                          transition="scale-transition"
                          offset-y
                          min-width="auto"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              v-model="drugToAdd.packExpirationDate"
                              append-icon="mdi-calendar"
                              outlined
                              dense
                              placeholder="Expiration Date"
                              readonly
                              v-bind="attrs"
                              v-on="on"
                              :disabled="!drugToAdd.packManufacturedDate"
                              :error-messages="errors.PackExpirationDate"
                            ></v-text-field>
                          </template>
                          <v-date-picker
                            v-model="drugToAdd.packExpirationDate"
                            @input="packexpmenu = false"
                            :min="
                              drugToAdd.packManufacturedDate
                                ? drugToAdd.packManufacturedDate
                                : new Date().toISOString().substr(0, 10)
                            "
                          ></v-date-picker>
                        </v-menu>
                      </div>
                    </v-col>
                  </v-row>
                </div>
              </v-expansion-panel-content>
            </v-expansion-panel>
            <v-expansion-panel class="mt-2">
              <v-expansion-panel-header class="text-h6 font-weight-bold">{{
                $t("drug.packOrder")
              }}</v-expansion-panel-header>
              <v-expansion-panel-content>
                <!-- <button
		type="button"
		class="accordion"
		@click="showHideSection('packOrder')"
	>
		Pack Order
		<v-icon> mdi-chevron-down </v-icon>
	</button> -->
                <div class="mt-5">
                  <v-row class="pa-5">
                    <v-col lg="4" md="4" sm="4" xs="6">
                      <div class="form-group">
                        <label for="drugRegdate"
                          >{{ $t("drug.packOrderID") }}
                        </label>
                        <v-tooltip top color="black" max-width="350">
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon small v-bind="attrs" v-on="on" class="ml-2">
                              mdi-information-outline
                            </v-icon>
                          </template>
                          <span>{{ $t("drug.packOrderIDState") }}</span>
                        </v-tooltip>
                        <v-text-field
                          type="text"
                          v-model="drugToAdd.packOrderId"
                          placeholder="Order ID"
                          outlined
                          dense
                          :rules="drugRules.packOrderId"
                        ></v-text-field>
                      </div>
                    </v-col>
                    <v-col lg="4" md="4" sm="4" xs="6">
                      <div class="form-group">
                        <label for="drugRegdate"
                          >{{ $t("drug.packQuantityOrdered") }}
                        </label>
                        <v-tooltip top color="black" max-width="350">
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon small v-bind="attrs" v-on="on" class="ml-2">
                              mdi-information-outline
                            </v-icon>
                          </template>
                          <span>{{ $t("drug.packQuantityOrderedState") }}</span>
                        </v-tooltip>
                        <v-layout row>
                          <v-col cols="6">
                            <v-text-field
                              v-model="drugToAdd.packQtyOrdered"
                              type="number"
                              placeholder="Quantity Order"
                              outlined
                              dense
                              :rules="drugRules.packQtyOrdered"
                            ></v-text-field>
                          </v-col>
                          <v-col cols="6">
                            <v-select
                              :items="unit"
                              placeholder="Unit"
                              outlined
                              dense
                            ></v-select>
                          </v-col>
                        </v-layout>
                      </div>
                    </v-col>
                    <v-col lg="4" md="4" sm="4" xs="6">
                      <div class="form-group">
                        <label for="drugRegdate"
                          >{{ $t("drug.packPrice") }}
                        </label>
                        <v-tooltip top color="black" max-width="350">
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon small v-bind="attrs" v-on="on" class="ml-2">
                              mdi-information-outline
                            </v-icon>
                          </template>
                          <span>{{ $t("drug.packPriceStatement") }}</span>
                        </v-tooltip>
                        <v-layout row>
                          <v-col cols="6">
                            <v-text-field
                              type="number"
                              v-model="drugToAdd.packPrice"
                              placeholder="Pack Price"
                              outlined
                              dense
                              :rules="drugRules.packPrice"
                            ></v-text-field>
                          </v-col>
                          <v-col cols="6">
                            <v-select
                              :items="uni"
                              placeholder="Unit"
                              outlined
                              dense
                            ></v-select>
                          </v-col>
                        </v-layout>
                      </div>
                    </v-col>
                    <!-- <v-col lg="4" md="4" sm="4" xs="6">
                      <div class="form-group">
                        <label for="brand">{{$t('drug.packPricecurrency')}}</label>
                        <v-tooltip top color="black" max-width="350">
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon small v-bind="attrs" v-on="on" class="ml-2">
                              mdi-information-outline
                            </v-icon>
                          </template>
                          <span>{{$t('drug.packPricecurrencyState')}}</span>
                        </v-tooltip>
                        <v-select
                          :items="curr"
                          v-model="drugToAdd.packPriceCurrency"
                          placeholder="Price Currency"
                          outlined
                          dense
                        ></v-select>
                      </div>
                    </v-col> -->
                    <v-col lg="4" md="4" sm="4" xs="6">
                      <div class="form-group">
                        <label for="brand">{{ $t("drug.packPaydate") }} </label>
                        <v-tooltip top color="black" max-width="350">
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon small v-bind="attrs" v-on="on" class="ml-2">
                              mdi-information-outline
                            </v-icon>
                          </template>
                          <span>{{ $t("drug.packPaydateState") }}</span>
                        </v-tooltip>
                        <v-menu
                          v-model="packpaymenu"
                          :close-on-content-click="false"
                          :nudge-right="40"
                          transition="scale-transition"
                          offset-y
                          min-width="auto"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              v-model="drugToAdd.packPayDate"
                              append-icon="mdi-calendar"
                              outlined
                              dense
                              readonly
                              placeholder="Pay Date"
                              v-bind="attrs"
                              v-on="on"
                            ></v-text-field>
                          </template>
                          <v-date-picker
                            v-model="drugToAdd.packPayDate"
                            @input="packpaymenu = false"
                            :min="new Date().toISOString().substr(0, 10)"
                          ></v-date-picker>
                        </v-menu>
                      </div>
                    </v-col>
                    <v-col lg="4" md="4" sm="4" xs="6">
                      <div class="form-group">
                        <label for="brand">{{
                          $t("drug.packShippingID")
                        }}</label>
                        <v-tooltip top color="black" max-width="350">
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon small v-bind="attrs" v-on="on" class="ml-2">
                              mdi-information-outline
                            </v-icon>
                          </template>
                          <span>{{ $t("drug.packShippingIdState") }}</span>
                        </v-tooltip>
                        <v-text-field
                          type="text"
                          v-model="drugToAdd.packShippingId"
                          placeholder="Shipping ID"
                          outlined
                          dense
                          :rules="drugRules.packShippingId"
                        ></v-text-field>
                      </div>
                    </v-col>
                    <v-col lg="4" md="4" sm="4" xs="6">
                      <div class="form-group">
                        <label for="brand">{{
                          $t("drug.packShippingDate")
                        }}</label>
                        <v-tooltip top color="black" max-width="350">
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon small v-bind="attrs" v-on="on" class="ml-2">
                              mdi-information-outline
                            </v-icon>
                          </template>
                          <span>{{ $t("drug.packShippingDateState") }}</span>
                        </v-tooltip>
                        <v-menu
                          v-model="animalRemovalmenu"
                          :close-on-content-click="false"
                          :nudge-right="40"
                          transition="scale-transition"
                          offset-y
                          min-width="auto"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              v-model="drugToAdd.packShippingDate"
                              append-icon="mdi-calendar"
                              outlined
                              dense
                              placeholder="Shipping Date"
                              readonly
                              v-bind="attrs"
                              v-on="on"
                            ></v-text-field>
                          </template>
                          <v-date-picker
                            v-model="drugToAdd.packShippingDate"
                            @input="animalRemovalmenu = false"
                            :min="drugToAdd.packPayDate"
                          ></v-date-picker>
                        </v-menu>
                      </div>
                    </v-col>
                    <v-col lg="4" md="4" sm="4" xs="6">
                      <div class="form-group">
                        <label for="brand">{{
                          $t("drug.packOrderStatus")
                        }}</label>
                        <v-tooltip top color="black" max-width="350">
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon small v-bind="attrs" v-on="on" class="ml-2">
                              mdi-information-outline
                            </v-icon>
                          </template>
                          <span>{{ $t("drug.packOrderStatusState") }}</span>
                        </v-tooltip>
                        <v-select
                          :items="orderStatus"
                          v-model="drugToAdd.packOrderStatus"
                          placeholder="Order Status"
                          outlined
                          dense
                          item-text="text"
                          item-value="value"
                        ></v-select>
                      </div>
                    </v-col>
                  </v-row>
                </div>
              </v-expansion-panel-content>
            </v-expansion-panel>
            <!-- <v-expansion-panel class="mt-2">
              <v-expansion-panel-header class="text-h6 font-weight-bold"
                >{{$t('drug.packPrescription')}}</v-expansion-panel-header
              >
              <v-expansion-panel-content> -->
            <!-- <button
              type="button"
              class="accordion"
              @click="showHideSection('packPrescription')"
            >
              Pack Prescription
              <v-icon> mdi-chevron-down </v-icon>
            </button> -->
            <!-- <div class="mt-5">
                  <v-row class="pa-5">
                    <v-col lg="4" md="4" sm="4" xs="6">
                      <div class="form-group">
                        <label for="drugRegdate">{{$t('drug.specialistID')}}</label>
                        <v-tooltip top color="black" max-width="350">
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon small v-bind="attrs" v-on="on" class="ml-2">
                              mdi-information-outline
                            </v-icon>
                          </template>
                          <span>{{$t('drug.specialistIDState')}}</span>
                        </v-tooltip>
                        <v-text-field
                          type="text"
                          v-model="drugToAdd.specialistId"
                          placeholder="Specialist ID"
                          outlined
                          dense
                          :rules="drugRules.specialistId"
                        ></v-text-field>
                      </div>
                    </v-col>
                    <v-col lg="4" md="4" sm="4" xs="6">
                      <div class="form-group">
                        <label for="drugRegdate">{{$t('drug.specialistName')}} </label>
                        <v-tooltip top color="black" max-width="350">
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon small v-bind="attrs" v-on="on" class="ml-2">
                              mdi-information-outline
                            </v-icon>
                          </template>
                          <span>{{$t('drug.specialistName')}}</span>
                        </v-tooltip>
                        <v-text-field
                          type="text"
                          v-model="drugToAdd.specialistName"
                          placeholder="Specialist Name"
                          outlined
                          dense
                          :rules="drugRules.specialistName"
                        ></v-text-field>
                      </div>
                    </v-col>
                    <v-col lg="4" md="4" sm="4" xs="6">
                      <div class="form-group">
                        <label for="drugRegdate">{{$t('drug.specialistComments')}} </label>
                        <v-tooltip top color="black" max-width="350">
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon small v-bind="attrs" v-on="on" class="ml-2">
                              mdi-information-outline
                            </v-icon>
                          </template>
                          <span>{{$t('drug.specialistComments')}}</span>
                        </v-tooltip>
                        <v-text-field
                          type="text"
                          v-model="drugToAdd.specialistComment"
                          placeholder="Specialist Comment"
                          outlined
                          dense
                        ></v-text-field>
                      </div>
                    </v-col>
                    <v-col lg="4" md="4" sm="4" xs="6">
                      <div class="form-group">
                        <label for="drugRegdate">{{$t('drug.recepientAnimalId')}}</label>
                        <v-tooltip top color="black" max-width="350">
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon small v-bind="attrs" v-on="on" class="ml-2">
                              mdi-information-outline
                            </v-icon>
                          </template>
                          <span>{{$t('drug.recepientAnimalId')}}</span>
                        </v-tooltip>
                        <v-text-field
                          type="text"
                          v-model="drugToAdd.packRecepientAnimalId"
                          placeholder="Animal ID"
                          outlined
                          dense
                          :rules="drugRules.packRecepientAnimalId"
                        ></v-text-field>
                      </div>
                    </v-col>
                    <v-col lg="4" md="4" sm="4" xs="6">
                      <div class="form-group">
                        <label for="drugRegdate">{{$t('drug.recepientFarmId')}}</label>
                        <v-tooltip top color="black" max-width="350">
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon small v-bind="attrs" v-on="on" class="ml-2">
                              mdi-information-outline
                            </v-icon>
                          </template>
                          <span>{{$t('drug.recepientFarmId')}}</span>
                        </v-tooltip>
                        <v-text-field
                          type="text"
                          v-model="drugToAdd.packRecepientFarmId"
                          placeholder="Farm ID"
                          outlined
                          dense
                          :rules="drugRules.packRecepientFarmId"
                        ></v-text-field>
                      </div>
                    </v-col>
                    <v-col lg="4" md="4" sm="4" xs="6">
                      <div class="form-group">
                        <label for="drugRegdate">{{$t('drug.recepientKeeperId')}}</label>
                        <v-tooltip top color="black" max-width="350">
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon small v-bind="attrs" v-on="on" class="ml-2">
                              mdi-information-outline
                            </v-icon>
                          </template>
                          <span>{{$t('drug.recepientKeeperId')}}</span>
                        </v-tooltip>
                        <v-text-field
                          type="text"
                          v-model="drugToAdd.packRecepientKeeperId"
                          placeholder="Keeper ID"
                          outlined
                          dense
                          :rules="drugRules.packRecepientKeeperId"
                        ></v-text-field>
                      </div>
                    </v-col>
                  </v-row>
                </div>
              </v-expansion-panel-content>
            </v-expansion-panel> -->
            <v-expansion-panel class="mt-2">
              <v-expansion-panel-header class="text-h6 font-weight-bold">{{
                $t("drug.packReservation")
              }}</v-expansion-panel-header>
              <v-expansion-panel-content>
                <!-- <button
              type="button"
              class="accordion"
              @click="showHideSection('packReservation')"
            >
              Pack Reservation
              <v-icon> mdi-chevron-down </v-icon>
            </button> -->
                <div class="mt-5">
                  <v-row class="pa-5">
                    <v-col lg="4" md="4" sm="4" xs="6">
                      <div class="form-group">
                        <label for="drugRegdate"
                          >{{ $t("drug.reservationStatus") }}
                        </label>
                        <v-tooltip top color="black" max-width="350">
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon small v-bind="attrs" v-on="on" class="ml-2">
                              mdi-information-outline
                            </v-icon>
                          </template>
                          <span>{{ $t("drug.reservationStatus") }}</span>
                        </v-tooltip>
                        <v-select
                          :items="reserveStatus"
                          v-model="drugToAdd.packReservationStatus"
                          placeholder="Reservation Status"
                          item-text="text"
                          item-value="value"
                          outlined
                          dense
                        ></v-select>
                      </div>
                    </v-col>
                    <v-col lg="4" md="4" sm="4" xs="6">
                      <div class="form-group">
                        <label for="drugRegdate"
                          >{{ $t("drug.reservationDate") }}
                        </label>
                        <v-tooltip top color="black" max-width="350">
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon small v-bind="attrs" v-on="on" class="ml-2">
                              mdi-information-outline
                            </v-icon>
                          </template>
                          <span>{{ $t("drug.reservationDate") }}</span>
                        </v-tooltip>
                        <v-menu
                          v-model="reservemenu"
                          :close-on-content-click="false"
                          :nudge-right="40"
                          transition="scale-transition"
                          offset-y
                          min-width="auto"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              v-model="drugToAdd.packReservationDate"
                              append-icon="mdi-calendar"
                              placeholder="Reservation Date"
                              outlined
                              dense
                              readonly
                              v-bind="attrs"
                              v-on="on"
                            ></v-text-field>
                          </template>
                          <v-date-picker
                            v-model="drugToAdd.packReservationDate"
                            @input="reservemenu = false"
                            :min="new Date().toISOString().substr(0, 10)"
                          ></v-date-picker>
                        </v-menu>
                      </div>
                    </v-col>
                    <v-col lg="4" md="4" sm="4" xs="6">
                      <div class="form-group">
                        <label for="drugRegdate"
                          >{{ $t("drug.reservationTimeout") }}
                        </label>
                        <v-tooltip top color="black" max-width="350">
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon small v-bind="attrs" v-on="on" class="ml-2">
                              mdi-information-outline
                            </v-icon>
                          </template>
                          <span>{{ $t("drug.reservationTimeout") }}</span>
                        </v-tooltip>
                        <v-text-field
                          type="text"
                          v-model="drugToAdd.packReservationTimeout"
                          placeholder="Reservation Timeout"
                          outlined
                          dense
                        ></v-text-field>
                      </div>
                    </v-col>
                    <v-col lg="4" md="4" sm="4" xs="6">
                      <div class="form-group">
                        <label for="drugRegdate"
                          >{{ $t("drug.reservationTimeoutDate") }}
                        </label>
                        <v-tooltip top color="black" max-width="350">
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon small v-bind="attrs" v-on="on" class="ml-2">
                              mdi-information-outline
                            </v-icon>
                          </template>
                          <span>{{ $t("drug.reservationTimeoutDate") }}</span>
                        </v-tooltip>
                        <v-menu
                          v-model="timeoutmenu"
                          :close-on-content-click="false"
                          :nudge-right="40"
                          transition="scale-transition"
                          offset-y
                          min-width="auto"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              v-model="drugToAdd.packReservationTimeoutDate"
                              append-icon="mdi-calendar"
                              outlined
                              placeholder="Timeout Date"
                              dense
                              readonly
                              v-bind="attrs"
                              v-on="on"
                            ></v-text-field>
                          </template>
                          <v-date-picker
                            v-model="drugToAdd.packReservationTimeoutDate"
                            @input="timeoutmenu = false"
                            :min="drugToAdd.packReservationDate"
                          ></v-date-picker>
                        </v-menu>
                      </div>
                    </v-col>
                    <v-col lg="4" md="4" sm="4" xs="6">
                      <div class="form-group">
                        <label for="drugRegdate"
                          >{{ $t("drug.reservedByFarmId") }}
                        </label>
                        <v-tooltip top color="black" max-width="350">
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon small v-bind="attrs" v-on="on" class="ml-2">
                              mdi-information-outline
                            </v-icon>
                          </template>
                          <span>{{ $t("drug.reservedByFarmId") }}</span>
                        </v-tooltip>
                        <v-text-field
                          type="text"
                          v-model="drugToAdd.packReservedByFarmId"
                          placeholder="Farm ID"
                          outlined
                          dense
                          :rules="drugRules.packReservedByFarmId"
                        ></v-text-field>
                      </div>
                    </v-col>
                    <v-col lg="4" md="4" sm="4" xs="6">
                      <div class="form-group">
                        <label for="drugRegdate">{{
                          $t("drug.reservedByKeeperId")
                        }}</label>
                        <v-tooltip top color="black" max-width="350">
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon small v-bind="attrs" v-on="on" class="ml-2">
                              mdi-information-outline
                            </v-icon>
                          </template>
                          <span>{{ $t("drug.reservedByKeeperId") }}</span>
                        </v-tooltip>
                        <v-text-field
                          type="text"
                          v-model="drugToAdd.packReservedBykeeperId"
                          placeholder="Keeper ID"
                          outlined
                          dense
                          :rules="drugRules.packReservedBykeeperId"
                        ></v-text-field>
                      </div>
                    </v-col>
                  </v-row>
                </div>
              </v-expansion-panel-content>
            </v-expansion-panel>
            <v-expansion-panel class="mt-2">
              <v-expansion-panel-header class="text-h6 font-weight-bold">{{
                $t("drug.packLocation")
              }}</v-expansion-panel-header>
              <v-expansion-panel-content>
                <!-- <button
	type="button"
	class="accordion"
	@click="showHideSection('packLocation')"
>
	Pack Location
	<v-icon> mdi-chevron-down </v-icon>
</button> -->
                <div class="mt-5">
                  <v-row class="pa-5">
                    <v-col lg="4" md="4" sm="4" xs="6">
                      <div class="form-group">
                        <label for="drugRegdate">{{
                          $t("drug.locationWarehouseID")
                        }}</label>
                        <v-tooltip top color="black" max-width="350">
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon small v-bind="attrs" v-on="on" class="ml-2">
                              mdi-information-outline
                            </v-icon>
                          </template>
                          <span>{{ $t("drug.locationWarehouseID") }}</span>
                        </v-tooltip>
                        <v-text-field
                          type="text"
                          v-model="drugToAdd.warehouseId"
                          placeholder="Warehouse ID"
                          outlined
                          dense
                          :rules="drugRules.warehouseId"
                        ></v-text-field>
                      </div>
                    </v-col>
                    <v-col lg="4" md="4" sm="4" xs="6">
                      <div class="form-group">
                        <label for="drugRegdate"
                          >{{ $t("drug.locationRackID") }}
                        </label>
                        <v-tooltip top color="black" max-width="350">
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon small v-bind="attrs" v-on="on" class="ml-2">
                              mdi-information-outline
                            </v-icon>
                          </template>
                          <span>{{ $t("drug.locationRackID") }}</span>
                        </v-tooltip>
                        <v-text-field
                          type="text"
                          v-model="drugToAdd.locationRackId"
                          placeholder="Rack ID"
                          outlined
                          dense
                          :rules="drugRules.locationRackId"
                        ></v-text-field>
                      </div>
                    </v-col>
                    <v-col lg="4" md="4" sm="4" xs="6">
                      <div class="form-group">
                        <label for="drugRegdate">{{
                          $t("drug.locationTierID")
                        }}</label>
                        <v-tooltip top color="black" max-width="350">
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon small v-bind="attrs" v-on="on" class="ml-2">
                              mdi-information-outline
                            </v-icon>
                          </template>
                          <span>{{ $t("drug.locationTierID") }}</span>
                        </v-tooltip>
                        <v-text-field
                          type="text"
                          v-model="drugToAdd.locationTierId"
                          placeholder="Tier ID"
                          outlined
                          dense
                          :rules="drugRules.locationTierId"
                        ></v-text-field>
                      </div>
                    </v-col>
                    <v-col lg="4" md="4" sm="4" xs="6">
                      <div class="form-group">
                        <label for="drugRegdate">{{
                          $t("drug.locationPositionID")
                        }}</label>
                        <v-tooltip top color="black" max-width="350">
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon small v-bind="attrs" v-on="on" class="ml-2">
                              mdi-information-outline
                            </v-icon>
                          </template>
                          <span>{{ $t("drug.locationPositionID") }}</span>
                        </v-tooltip>
                        <v-text-field
                          type="text"
                          v-model="drugToAdd.locationPositionId"
                          placeholder="Position ID"
                          outlined
                          dense
                          :rules="drugRules.locationPositionId"
                        ></v-text-field>
                      </div>
                    </v-col>
                    <v-col lg="4" md="4" sm="4" xs="6">
                      <div class="form-group">
                        <label for="drugRegdate"
                          >{{ $t("drug.storageTemperatureCondition") }}
                        </label>
                        <v-tooltip top color="black" max-width="350">
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon small v-bind="attrs" v-on="on" class="ml-2">
                              mdi-information-outline
                            </v-icon>
                          </template>
                          <span>{{
                            $t("drug.storageTemperatureCondition")
                          }}</span>
                        </v-tooltip>
                        <v-select
                          :items="tempCond"
                          v-model="drugToAdd.packStorageTemperatureOptId"
                          placeholder="Temperature Condition"
                          item-text="name"
                          item-value="id"
                          outlined
                          dense
                        ></v-select>
                      </div>
                    </v-col>
                    <v-col lg="4" md="4" sm="4" xs="6">
                      <div class="form-group">
                        <label for="drugRegdate"
                          >{{ $t("drug.containerForm") }}
                        </label>
                        <v-tooltip top color="black" max-width="350">
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon small v-bind="attrs" v-on="on" class="ml-2">
                              mdi-information-outline
                            </v-icon>
                          </template>
                          <span>{{ $t("drug.containerForm") }}</span>
                        </v-tooltip>
                        <v-select
                          :items="items"
                          v-model="drugToAdd.packContainerFormOptId"
                          placeholder="Container Form"
                          item-text="name"
                          item-value="id"
                          outlined
                          dense
                        ></v-select>
                      </div>
                    </v-col>
                    <v-col lg="4" md="4" sm="4" xs="6">
                      <div class="form-group">
                        <label for="drugRegdate">{{
                          $t("drug.consistQuantity")
                        }}</label>
                        <v-tooltip top color="black" max-width="350">
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon small v-bind="attrs" v-on="on" class="ml-2">
                              mdi-information-outline
                            </v-icon>
                          </template>
                          <span>{{ $t("drug.consistQuantity") }}</span>
                        </v-tooltip>
                        <v-text-field
                          type="number"
                          v-model="drugToAdd.packConsistQty"
                          placeholder="Consist Quantity"
                          outlined
                          dense
                          :rules="drugRules.packConsistQty"
                        ></v-text-field>
                      </div>
                    </v-col>
                    <v-col lg="4" md="4" sm="4" xs="6">
                      <div class="form-group">
                        <label for="drugRegdate">{{
                          $t("drug.releaseId")
                        }}</label>
                        <v-tooltip top color="black" max-width="350">
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon small v-bind="attrs" v-on="on" class="ml-2">
                              mdi-information-outline
                            </v-icon>
                          </template>
                          <span>{{ $t("drug.releaseId") }}</span>
                        </v-tooltip>
                        <v-text-field
                          type="text"
                          v-model="drugToAdd.packReleaseId"
                          placeholder="Released ID"
                          outlined
                          dense
                          :rules="drugRules.packReleaseId"
                        ></v-text-field>
                      </div>
                    </v-col>
                    <v-col lg="4" md="4" sm="4" xs="6">
                      <div class="form-group">
                        <label for="drugRegdate"
                          >{{ $t("drug.releaseDate") }}
                        </label>
                        <v-tooltip top color="black" max-width="350">
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon small v-bind="attrs" v-on="on" class="ml-2">
                              mdi-information-outline
                            </v-icon>
                          </template>
                          <span>{{ $t("drug.releaseDate") }}</span>
                        </v-tooltip>
                        <v-menu
                          v-model="releasemenu"
                          :close-on-content-click="false"
                          :nudge-right="40"
                          transition="scale-transition"
                          offset-y
                          min-width="auto"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              v-model="drugToAdd.packReleaseDate"
                              append-icon="mdi-calendar"
                              outlined
                              dense
                              placeholder="Released Date"
                              readonly
                              v-bind="attrs"
                              v-on="on"
                            ></v-text-field>
                          </template>
                          <v-date-picker
                            v-model="drugToAdd.packReleaseDate"
                            @input="releasemenu = false"
                            :min="new Date().toISOString().substr(0, 10)"
                          ></v-date-picker>
                        </v-menu>
                      </div>
                    </v-col>
                    <v-col cols="6" class="display-none"> </v-col>
                    <v-col cols="3" class="display-none"> </v-col>
                  </v-row>
                </div>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </div>
        <div class="registration-btn bottom-btn">
          <v-btn
            width="146"
            class="mr-2"
            outlined
            color="primary"
            exact
            :to="{ name: 'DrugList' }"
            >{{ $t("actionListmod.cANCEL") }}</v-btn
          >
          <v-btn width="146" type="submit" dark color="primary">{{
            $t("actionListmod.sUBMIT")
          }}</v-btn>
        </div>
      </v-form>
    </v-container>
  </div>
</template>

<script>
import loading from "@/mixins/LoadingMixin";
import { drugRules } from "@/validations/DrugFormRules.js";
import { createDrug, getOptions } from "@/graphql/Drug.gql";
export default {
  apollo: {
    getOptions: {
      query: getOptions,
      update: (data) => data.getOptions,
      fetchPolicy: "no-cache",
      variables() {
        return {};
      },
      result({ data }) {
        const packStorageTemperature = data.getOptions.find(
          (temp) => temp.groupName == "pack-storage-temperature"
        );
        this.tempCond = packStorageTemperature.options;
        const packContainerForm = data.getOptions.find(
          (pack) => pack.groupName == "pack-container-form"
        );

        this.items = packContainerForm.options;
      },
    },
  },
  // created() {
  // 	this.breadcrumbs = this.$route.meta.breadcrumbs;
  // },
  mounted() {
    // this.loadOptions();
  },
  data() {
    return {
      // animalRemovalmenu: false,
      drugRegmenu: false,
      drugMfgmenu: false,
      importedmenu: false,
      packexpmenu: false,
      packpaymenu: false,
      releasemenu: false,
      openRequired: false,
      reservemenu: false,
      timeoutmenu: false,
      panel: 0,
      drugRules,
      valid: true,
      tempCond: [
        {
          id: 60,
          name: "store below -18 °C (in a deep freezer)",
        },
        {
          id: 58,
          name: "store below 8 °C (under refrigeration)",
        },
        {
          id: 59,
          name: "store between -5 and -20 °C (in a freezer)",
        },
        {
          id: 57,
          name: "store between 2 and 8 °C (under refrigeration, no freezing)",
        },
        {
          id: 56,
          name: "store under normal storage conditions",
        },
      ],
      items: [
        {
          id: 61,
          name: "ampoule",
        },
        {
          id: 62,
          name: "bag",
        },
        {
          id: 63,
          name: "blister",
        },
        {
          id: 64,
          name: "bottle",
        },
        {
          id: 65,
          name: "cartridge",
        },
        {
          id: 66,
          name: "gas cylinder",
        },
        {
          id: 67,
          name: "injection needle",
        },
        {
          id: 68,
          name: "injection syringe",
        },
        {
          id: 69,
          name: "pressurized container",
        },
        {
          id: 70,
          name: "single-dose container",
        },
        {
          id: 71,
          name: "stip",
        },
        {
          id: 72,
          name: "tube",
        },
        {
          id: 73,
          name: "vial",
        },
      ],
      uni: ["unit"],
      curr: ["INR", "USD"],
      orderStatus: [
        { text: "Ordered", value: "ordered" },
        { text: "Paid", value: "paid" },
        { text: "Received", value: "received" },
        { text: "Stocked", value: "stocked" },
      ],
      reserveStatus: [
        { text: "Reserved", value: "reserved" },
        { text: "Free", value: "free" },
      ],
      unit: ["times"],
      breadcrumbs: [
        {
          text: this.$t("dashboard"),
          disabled: false,
          to: "/",
        },
        {
          text: this.$t("drugInventory"),
          disabled: false,
          exact: true,
          link: true,
          to: { name: "DrugList" },
        },
        {
          text: this.$t("drug.registerAdrug"),
          disabled: true,
          href: "breadcrumbs_link_1",
        },
      ],
      drugToAdd: {
        drugNumber: null,
        drugName: "",
        genericName: "",
        drugFormat: "",
        activeIngredients: "",
        distributor: "",
        registrationDate: "",
        manufacturer: "",
        substituteDrugNo: "",
        packId: "",
        packBatchNumber: "",
        packManufacturedDate: null,
        packExpirationDate: null,
        packTotalVolLeft: null,
        packTotalVolLeftUnit: "",
        packOrderId: "",
        packQtyOrdered: null,
        packQtyOrderedUnit: "",
        packPrice: null,
        packPriceCurrency: "",
        packPayDate: null,
        packShippingId: "",
        packShippingDate: null,
        packOrderStatus: null,
        packReservationStatus: null,
        packReservationDate: null,
        packReservationTimeout: null,
        packReservationTimeoutDate: null,
        packReservedByFarmId: "",
        packReservedBykeeperId: "",
        warehouseId: null,
        locationRackId: "",
        locationTierId: "",
        locationPositionId: "",
        packStorageTemperatureOptId: null,
        packContainerFormOptId: null,
        packConsistQty: null,
        packReleaseId: "",
        packReleaseDate: null,
      },
      errors: {
        PackExpirationDate: "",
      },
    };
  },
  methods: {
    showHideSection(section) {
      var panel = this.$refs[section];
      panel.style.maxHeight = panel.style.maxHeight
        ? null
        : panel.scrollHeight + "%";
    },
    // loadOptions() {
    //   const options = {
    //     options: ["pack-container-form", "pack-storage-temperature"],
    //   };
    //   GeneralService.getDropdownData(options).then((data) => {
    //     let newdata = data.data["pack-container-form"];
    //     console.log(newdata);
    //     this.items = newdata;
    //     let ownerdata = data.data["pack-storage-temperature"];
    //     this.tempCond = ownerdata;
    //   });
    // },
    // setExpire(date){
    //   console.log(date)
    //   if(date<this.drugToAdd.PackExpirationDate){
    //     this.drugToAdd.PackExpirationDate=date
    //   }else{
    //     this.errors.PackExpirationDate="Expiration Date must be greater than manufacture Date"
    //   }
    // },
    registerDrug() {
      if (!this.$refs.form.validate()) return;
      this.startLoading();
      console.log("res", this.drugToAdd);

      this.drugToAdd.packTotalVolLeft = +this.drugToAdd.packTotalVolLeft;
      this.drugToAdd.warehouseId = +this.drugToAdd.warehouseId;
      this.drugToAdd.packConsistQty = +this.drugToAdd.packConsistQty;
      this.drugToAdd.packQtyOrdered = +this.drugToAdd.packQtyOrdered;
      this.drugToAdd.packPrice = this.drugToAdd?.packPrice
        ? parseFloat(this.drugToAdd.packPrice)
        : null;
      this.drugToAdd.packReservationTimeout =
        +this.drugToAdd.packReservationTimeout;

      this.$apollo
        .mutate({
          mutation: createDrug,
          variables: {
            createDrugInput: this.drugToAdd,
          },
        })
        .then(() => {
          debugger;
          this.$notify({
            title: "Success!!",
            text: "Drug registered successfully!",
            type: "success",
          });

          this.stopLoading();
          this.$router.push({ name: "DrugList" });
        })
        .catch(() => {
          this.$notify({
            title: "Error!!",
            text: "Unable to register drug!",
            type: "error",
          });
          console.log(this.errors);
          this.stopLoading();
        });
    },
  },
  mixins: [loading],
};
</script>

<style lang="scss" scoped>
.registration-section .main-register {
  display: flex;
  justify-content: space-between;
}
.registration-heading {
  display: flex;
  align-items: center;
}
.registration-section .registration-heading h2 {
  /* color:#6A7784; */
  /* font-size: 20px; */
  font-family: Poppins-Medium;
}
.registration-section .registration-heading span {
  width: 1px;
  height: 30px;
  /* background: #6A7784; */
  margin: 0px 15px;
}
.registration-section .registration-heading p {
  /* color: #97A8B8; */
  font-size: 20px;
  font-family: Poppins-Medium;
}
.registration-btn {
  display: flex;
  align-items: center;
}
.registration-btn.bottom-btn {
  margin: 30px 22px 0px 0px;
  justify-content: flex-end;
  padding: 24px 15px;
  /* border-top: 1px solid #dae1ec; */
  width: 100%;
}
.registration-section label {
  display: inline-block;
  margin-bottom: 0.5rem;
  /* color: #97A8B8; */
  font-size: 14px;
  font-family: Poppins-Medium;
  letter-spacing: 0.5px;
  white-space: nowrap;
}

.mandatory {
  font-size: 14px;
  font-weight: 100;
  font-family: pop_light;
  margin: 20px 0px;
}
.accordion {
  cursor: pointer;
  padding: 10px;
  width: 100%;
  text-align: left;
  transition: 0.4s;
  background: #fafcff;
  border: 1px solid #c7d5e1;
  /* color: #6A7784; */
  font-size: 14px;
  font-family: pop_semiBold;
  margin-bottom: 15px;
  border-radius: 5px;
}
.panel {
  /* padding: 15px 15px; */
  background-color: white;
  max-height: 0;
  overflow: hidden;
  transition: max-height 0.2s ease-out;
  margin-bottom: 20px;
}

.drug-form.margin-cell-3 {
  margin-top: 20px;
}
.drug-form {
  display: inline;
}
.drug-form label {
  display: inline-block;
  margin-bottom: 0.5rem;
  /* color: #97A8B8; */
  font-size: 14px;
  font-family: Poppins-Medium;
  letter-spacing: 0.5px;
  white-space: nowrap;
}
.drug-form .form-control {
  display: block;
  width: 100%;
  height: 50px;
  padding: 0.375rem 0.75rem;
  font-size: 14px;
  font-weight: 400;
  // line-height: 1.5;
  // color: #495057;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  // background: #fff;
  // border: 1px solid #c7d5e1;
  border-radius: 3px;
  // color: #c7d5e1;
  font-family: pop_regular;
}
.drug-form .form-control:focus-visible,
.form-control-2:focus-visible {
  outline: none;
}
.drug-form .form-control::placeholder {
  font-size: 14px;
  // color: #c7d5e1;
  font-family: pop_regular;
}

.drug-form .form-control-2 {
  display: block;
  width: 100%;
  height: 50px;
  padding: 1px 20px;
  line-height: 1.5;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  background: #fff;
  border: 1px solid #c7d5e1;
  border-radius: 3px;
  background-position: calc(100% - 1.2rem) center !important;
  -moz-appearance: none !important;
  -webkit-appearance: none !important;
  appearance: none !important;
  /* background-image: url(../img/drop2.png); */
  background-repeat: no-repeat;
  font-size: 14px;
  color: #c7d5e1;
  font-family: pop_regular;
}

.cell-2 {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.cell-2 h2 {
  font-size: 14px;
  color: #70a4d3;
  font-family: Poppins-Medium;
  font-weight: 100;
}
.margin-cell {
  margin-top: 20px;
}
.form-group span {
  color: red;
}
</style>
